import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ApplicationService } from '@services/api-calls/application.service';

export const appGuidInterceptor: HttpInterceptorFn = (req, next) => {
    const applicationService = inject(ApplicationService);
    const guid = applicationService.applicationGuid();

    if (guid) {
        req = req.clone({
            setHeaders: {
                'x-app-guid': guid,
            },
        });
    }

    return next(req);
};
